/* ============================================================
   i40 PRODUCT PAGE BEHAVIORS — ported from the ATP build (Jul 2026)
   - Countdown to the same-day-shipping cutoff (America/New_York,
     business days only, rolls past-cutoff/weekend to next business day)
   - Live open/closed status pills (shared engine, also used by header)
   - Tab strip decoration: theme + review app JS REBUILD the strip after
     load, so decoration is re-applied via MutationObserver using REAL
     DOM NODES (never innerHTML)
   - ZIP shipping estimator: pure client-side, no API. Estimates stay
     inside the store's advertised 3-7 business-day ground window.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- America/New_York clock ---------- */
  var ET_FMT = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour12: false,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
  var DAY_IDX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var DAY_NAME = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function etNow() {
    var parts = {};
    ET_FMT.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var h = parseInt(parts.hour, 10) % 24; // some engines emit "24" at midnight
    return {
      day: DAY_IDX[parts.weekday],
      sec: h * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10)
    };
  }

  function parseDays(str) {
    return String(str || '1,2,3,4,5').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return n >= 0 && n <= 6; });
  }

  function parseHM(str, fallbackH, fallbackM) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(str || '').trim());
    if (!m) return { h: fallbackH, m: fallbackM };
    return { h: Math.min(23, parseInt(m[1], 10)), m: Math.min(59, parseInt(m[2], 10)) };
  }

  function fmt12(h, m) {
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if (hh === 0) hh = 12;
    return hh + ':' + ('0' + m).slice(-2) + ' ' + ap;
  }

  /* ============================================================
     COUNTDOWN — #i40Countdown[data-cutoff-h][data-cutoff-m][data-days]
     ============================================================ */
  function initCountdown() {
    var box = document.getElementById('i40Countdown');
    if (!box) return;
    var timerEl = document.getElementById('i40Timer');
    var dayEl = document.getElementById('i40ShipDay');
    if (!timerEl || !dayEl) return;

    var cutoffSec = (parseInt(box.dataset.cutoffH, 10) || 18) * 3600 + (parseInt(box.dataset.cutoffM, 10) || 0) * 60;
    var bizDays = parseDays(box.dataset.days);
    var isBiz = function (d) { return bizDays.indexOf(d) !== -1; };

    var left = 0; // seconds until cutoff, resynced against ET regularly

    function resync() {
      var now = etNow();
      var offsetDays = null;
      if (isBiz(now.day) && now.sec < cutoffSec) {
        offsetDays = 0;
      } else {
        for (var n = 1; n <= 7; n++) {
          if (isBiz((now.day + n) % 7)) { offsetDays = n; break; }
        }
      }
      if (offsetDays === null) offsetDays = 1;
      left = offsetDays * 86400 + cutoffSec - now.sec;
      dayEl.textContent = offsetDays === 0 ? 'today' : (offsetDays === 1 ? 'tomorrow' : DAY_NAME[(now.day + offsetDays) % 7]);
    }

    function paint() {
      if (left < 0) left = 0;
      var h = Math.floor(left / 3600);
      var m = Math.floor((left % 3600) / 60);
      var s = left % 60;
      timerEl.textContent = ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2) + ':' + ('0' + s).slice(-2);
    }

    resync(); paint();
    var tick = 0;
    setInterval(function () {
      left--; tick++;
      if (tick >= 30 || left <= 0) { resync(); tick = 0; } // stay honest across DST/sleep
      paint();
    }, 1000);
  }

  /* ============================================================
     OPEN/CLOSED STATUS — [data-i40-status][data-open][data-close][data-days]
     Shared with the header pills. Exposed as window.__i40Status.
     ============================================================ */
  function statusSweep() {
    var pills = document.querySelectorAll('[data-i40-status]');
    if (!pills.length) return;
    var now = etNow();
    pills.forEach(function (pill) {
      var open = parseHM(pill.dataset.open, 8, 0);
      var close = parseHM(pill.dataset.close, 22, 30);
      var days = parseDays(pill.dataset.days);
      var openSec = open.h * 3600 + open.m * 60;
      var closeSec = close.h * 3600 + close.m * 60;
      var isOpen = days.indexOf(now.day) !== -1 && now.sec >= openSec && now.sec < closeSec;
      var txt = pill.querySelector('.i40-pill-text') || pill.querySelector('.i40-hc-statusline');
      pill.classList.toggle('is-on', isOpen);
      if (!txt) return;
      if (isOpen) {
        txt.textContent = 'Open for business — until ' + fmt12(close.h, close.m) + ' ET';
      } else {
        var n, d = null;
        for (n = 1; n <= 7; n++) { d = (now.day + n) % 7; if (days.indexOf(d) !== -1) break; }
        if (days.indexOf(now.day) !== -1 && now.sec < openSec) { d = now.day; n = 0; }
        var label = n === 0 ? 'today' : (n === 1 ? 'tomorrow' : DAY_NAME[d]);
        txt.textContent = 'Closed — opens ' + label + ' ' + fmt12(open.h, open.m) + ' ET';
      }
    });
  }
  if (!window.__i40Status) {
    window.__i40Status = true;
    statusSweep();
    setInterval(statusSweep, 30000);
  }

  /* ============================================================
     TAB DECORATION — real nodes + MutationObserver (never innerHTML;
     Judge.me and the theme both rebuild the strip after load)
     ============================================================ */
  var SVG_NS = 'http://www.w3.org/2000/svg';
  function mkCheck() {
    var wrap = document.createElement('span');
    wrap.className = 'i40-tab-check';
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('fill', 'currentColor');
    path.setAttribute('d', 'M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z');
    svg.appendChild(path);
    wrap.appendChild(svg);
    return wrap;
  }
  function mkStars() {
    var s = document.createElement('span');
    s.className = 'i40-tab-stars';
    s.setAttribute('aria-hidden', 'true');
    s.textContent = '\u2605\u2605\u2605\u2605\u2605';
    return s;
  }

  /* wrap a tab's existing children in a first-line span so the check icon
     sits INLINE with the label while stars go on their own line below —
     exactly the ATP strip. Idempotent for the MutationObserver. */
  function lineOf(li) {
    var line = li.querySelector('.i40-tab-line');
    if (line) return line;
    line = document.createElement('span');
    line.className = 'i40-tab-line';
    while (li.firstChild) line.appendChild(li.firstChild);
    li.appendChild(line);
    return line;
  }

  function decorateTabs() {
    var panel = document.querySelector('.js-tab-panel');
    if (!panel) return;
    var controls = panel.querySelector('.js-tab-controls');
    if (!controls) return;
    var showStars = !!document.querySelector('.i40-tc-reviews');

    Array.prototype.forEach.call(controls.children, function (li) {
      if (li.nodeType !== 1) return;
      var t = (li.textContent || '').toLowerCase();
      var target = li.getAttribute('data-target') || '';
      var content = target ? panel.querySelector(target) : null;

      if (/fitment|verify/.test(t)) {
        li.classList.add('i40-tab-fit');
        var lf = lineOf(li);
        if (!lf.querySelector('.i40-tab-check')) lf.insertBefore(mkCheck(), lf.firstChild);
        if (content) content.classList.add('i40-c-fit');
      } else if (/review/.test(t)) {
        li.classList.add('i40-tab-rev');
        lineOf(li);
        if (!li.querySelector('.i40-tab-stars')) li.appendChild(mkStars());
        if (!showStars) { var st = li.querySelector('.i40-tab-stars'); if (st) st.style.display = 'none'; }
        if (content) content.classList.add('i40-c-rev');
      } else if (/shipping|refund|delivery|return/.test(t)) {
        li.classList.add('i40-tab-ship');
        lineOf(li);
        if (content) content.classList.add('i40-c-ship');
      }
    });
  }

  function initTabs() {
    var panel = document.querySelector('.js-tab-panel');
    if (!panel) return;
    decorateTabs();
    var pending = null;
    new MutationObserver(function () {
      // decoration mutates the strip too — idempotent + debounced keeps it calm
      if (pending) return;
      pending = setTimeout(function () { pending = null; decorateTabs(); }, 120);
    }).observe(panel, { childList: true, subtree: true });
  }

  /* trust-column "Verify Fitment" badge -> open the fitment tab */
  function initFitmentJump() {
    var link = document.querySelector('.js-i40-goto-fitment');
    if (!link) return;
    link.addEventListener('click', function () {
      var controls = document.querySelectorAll('.js-tab-controls > li');
      Array.prototype.some.call(controls, function (li) {
        if (/fitment|verify/.test((li.textContent || '').toLowerCase())) { li.click(); return true; }
        return false;
      });
    });
  }

  /* ============================================================
     ZIP ESTIMATOR — #i40Zip[data-origin]
     First-digit USPS regions as a coarse distance proxy; output is a
     RANGE clamped to the advertised 3-7 business-day ground window.
     ============================================================ */
  /* ============================================================
     ZIP ESTIMATOR v2 — "integrated with Shopify" like ATP's:
     1. City names for both ZIPs (zippopotam.us, fail-soft to raw ZIPs)
     2. REAL shipping options from Shopify's cart rates endpoint.
        Empty cart? The current variant is silently added, rates are
        fetched, and it is ALWAYS removed again (try/finally-style).
     3. Anything fails -> the old first-digit 3-7 day range as a
        clearly-labeled estimate. Never a dead widget.
     ============================================================ */
  function initZip() {
    var box = document.getElementById('i40Zip');
    if (!box) return;
    var form = document.getElementById('i40ZipForm');
    var input = document.getElementById('i40ZipInput');
    var out = document.getElementById('i40ZipResult');
    if (!form || !input || !out) return;

    var head = box.querySelector('.i40-zip-head');
    if (head) {
      head.addEventListener('click', function () {
        var collapsed = box.classList.toggle('is-collapsed');
        head.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    }

    var origin = String(box.dataset.origin || '').trim();
    var originPlace;
    var busy = false;
    var RANGE = ['3\u20134', '3\u20135', '4\u20135', '4\u20136', '5\u20136', '5\u20137', '5\u20137', '5\u20137', '5\u20137', '5\u20137'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

    function placeFor(zip) {
      return fetch('https://api.zippopotam.us/us/' + zip)
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) {
          var pl = d.places && d.places[0];
          return pl ? { city: pl['place name'], state: pl['state abbreviation'] } : null;
        })
        .catch(function () { return null; });
    }

    function ratesFor(zip, province) {
      var url = '/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + encodeURIComponent(zip) +
        '&shipping_address%5Bcountry%5D=' + encodeURIComponent('United States') +
        (province ? '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province) : '');
      var tries = 0;
      function attempt() {
        return fetch(url).then(function (r) {
          if (r.status === 200) return r.json().then(function (d) { return (d && d.shipping_rates) || null; });
          if ((r.status === 202 || r.status === 429) && tries++ < 4) return wait(800).then(attempt);
          return null;
        }).catch(function () { return null; });
      }
      return attempt();
    }

    function cartCount() {
      return fetch('/cart.js').then(function (r) { return r.json(); })
        .then(function (c) { return c.item_count; })
        .catch(function () { return null; });
    }

    function variantId() {
      var el = document.getElementById('selected_variant');
      return el && el.value ? el.value : null;
    }

    function addTemp(vid) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    function removeTemp(vid) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(vid), quantity: 0 })
      }).catch(function () { });
    }

    function fmtDate(str) {
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(str || ''));
      if (!m) return '';
      return MONTHS[parseInt(m[2], 10) - 1] + ' ' + parseInt(m[3], 10);
    }

    function money(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return '';
      return n === 0 ? 'FREE' : '$' + n.toFixed(2);
    }

    function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }

    function label(place, zip) {
      return place ? place.city + ', ' + place.state : 'ZIP ' + zip;
    }

    function renderHeaderLine(destPlace, zip) {
      var from = document.createElement('p');
      from.className = 'i40-zip-from';
      from.textContent = 'From ' + label(originPlace, origin) + ' to ' + label(destPlace, zip) + ':';
      out.appendChild(from);
    }

    function renderRates(rates) {
      rates.slice(0, 4).forEach(function (rate) {
        var row = document.createElement('div');
        row.className = 'i40-rate';
        var n = document.createElement('span');
        n.className = 'n';
        n.appendChild(document.createTextNode(rate.name || 'Shipping'));
        var range = '';
        if (rate.delivery_range && rate.delivery_range.length) {
          var a = fmtDate(rate.delivery_range[0]);
          var b = fmtDate(rate.delivery_range[rate.delivery_range.length - 1]);
          if (a) range = 'Est. delivery ' + (b && b !== a ? a + ' \u2013 ' + b : a);
        } else if (rate.delivery_date) {
          var d = fmtDate(rate.delivery_date);
          if (d) range = 'Est. delivery ' + d;
        }
        if (range) {
          var sm = document.createElement('small');
          sm.textContent = range;
          n.appendChild(sm);
        }
        var pr = document.createElement('span');
        pr.className = 'p';
        pr.textContent = money(rate.price);
        row.appendChild(n);
        row.appendChild(pr);
        out.appendChild(row);
      });
    }

    function renderFallback(zip) {
      var dist = Math.abs(parseInt(zip[0], 10) - parseInt((origin[0] || '2'), 10));
      var p = document.createElement('p');
      p.appendChild(document.createTextNode('Ground estimate: '));
      var strong = document.createElement('strong');
      strong.textContent = RANGE[Math.min(dist, RANGE.length - 1)] + ' business days';
      p.appendChild(strong);
      p.appendChild(document.createTextNode(' after your order ships.'));
      out.appendChild(p);
    }

    function renderNote() {
      if (box.dataset.hasCutoff !== '1') return;
      var note = document.createElement('p');
      note.className = 'i40-zip-note';
      note.textContent = 'Order before the cutoff and it is processed the same business day.';
      out.appendChild(note);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var zip = input.value.trim();
      if (!/^\d{5}$/.test(zip)) {
        out.className = 'i40-zip-result err';
        clear(out);
        out.appendChild(document.createTextNode('Please enter a valid 5-digit US ZIP code.'));
        return;
      }
      busy = true;
      var btn = form.querySelector('button');
      if (btn) btn.disabled = true;
      out.className = 'i40-zip-result loading';
      clear(out);
      out.appendChild(document.createTextNode('Checking live rates\u2026'));

      var originLookup = originPlace ? Promise.resolve(originPlace) : placeFor(origin);
      Promise.all([originLookup, placeFor(zip)]).then(function (places) {
        originPlace = places[0] || originPlace;
        var destPlace = places[1];
        var province = destPlace ? destPlace.state : '';

        return cartCount().then(function (count) {
          if (count > 0) return ratesFor(zip, province);
          var vid = variantId();
          if (!vid) return null;
          return addTemp(vid).then(function (added) {
            if (!added) return null;
            return ratesFor(zip, province).then(
              function (rates) { return removeTemp(vid).then(function () { return rates; }); },
              function () { return removeTemp(vid).then(function () { return null; }); }
            );
          });
        }).then(function (rates) {
          out.className = 'i40-zip-result';
          clear(out);
          renderHeaderLine(destPlace, zip);
          if (rates && rates.length) {
            renderRates(rates);
          } else {
            renderFallback(zip);
          }
          renderNote();
        });
      }).catch(function () {
        out.className = 'i40-zip-result';
        clear(out);
        renderHeaderLine(null, zip);
        renderFallback(zip);
        renderNote();
      }).then(function () {
        busy = false;
        if (btn) btn.disabled = false;
      });
    });
  }

  /* express box -> fire the buyer's real wallet button (Shopify's dynamic
     checkout renders their preferred wallet); fallback: scroll + pulse it */
  function initExpress() {
    var box = document.querySelector('.js-i40-express');
    if (!box) return;
    box.addEventListener('click', function () {
      var scope = document.querySelector('.i40-product') || document;
      var btn = scope.querySelector('.shopify-payment-button__button:not([disabled])');
      if (btn) { btn.click(); return; }
      var area = scope.querySelector('.dynamic-checkout, .shopify-payment-button');
      if (area) {
        area.scrollIntoView({ behavior: 'smooth', block: 'center' });
        area.classList.add('i40-pay-pulse');
        setTimeout(function () { area.classList.remove('i40-pay-pulse'); }, 2000);
      }
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    initCountdown();
    initTabs();
    initFitmentJump();
    initZip();
    initExpress();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
